import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      isActive: $setup.loading,
      title: "Loading..."
    }, null, 8 /* PROPS */, ["isActive"]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createCommentVNode(" App Context Toggle "),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_toggle, {
                  modelValue: $setup.appContext,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.appContext) = $event)),
                  mandatory: "",
                  color: "primary",
                  density: "comfortable"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, { value: "POINT" }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("POINT")
                      ])),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_btn, { value: "Operation" }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("Operation")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" Menu Items Grid "),
        _createVNode(_component_v_row, { class: "mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "text-left" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      headers: $setup.menuHeaders,
                      items: $setup.menuItems,
                      loading: $setup.loading,
                      density: "comfortable",
                      class: "elevation-0",
                      "no-data-text": "No menu items found",
                      "items-per-page": "25",
                      hover: ""
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_v_toolbar, { flat: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar_title, null, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("Command Center Menu Items")
                              ])),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_divider, {
                              class: "mx-4",
                              inset: "",
                              vertical: ""
                            }),
                            _createVNode(_component_v_chip, { class: "mr-2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.menuItems.length) + " items", 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_m_btn, {
                              color: "primary",
                              "prepend-icon": "mdi-plus",
                              onClick: $setup.openAddDialog,
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode("Add")
                              ])),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _createVNode(_component_m_btn, {
                              color: "primary",
                              "prepend-icon": "mdi-refresh",
                              onClick: $setup.loadMenuItems
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode("Refresh")
                              ])),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      "item.menuPgm": _withCtx(({ item }) => [
                        _createTextVNode(_toDisplayString(item.menuPgm === 'M' ? 'Menu' : 'Program'), 1 /* TEXT */)
                      ]),
                      "item.actions": _withCtx(({ item }) => [
                        _createVNode(_component_v_btn, {
                          icon: "",
                          size: "small",
                          variant: "text",
                          color: "primary",
                          onClick: ($event: any) => ($setup.openEditDialog(item)),
                          title: "Edit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                _createTextVNode("mdi-pencil")
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          icon: "",
                          size: "small",
                          variant: "text",
                          color: "error",
                          onClick: ($event: any) => ($setup.confirmDelete(item)),
                          title: "Delete"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createTextVNode("mdi-trash-can-outline")
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["headers", "items", "loading"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" Add/Edit Menu Item Dialog "),
        _createVNode(_component_v_dialog, {
          modelValue: $setup.showMenuDialog,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.showMenuDialog) = $event)),
          "max-width": "800",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.editingItem ? 'Edit Menu Item' : 'Add Menu Item'), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.menuForm.menuId,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.menuForm.menuId) = $event)),
                              label: "Menu ID *",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "10",
                              disabled: !!$setup.editingItem
                            }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.menuForm.sequence,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.menuForm.sequence) = $event)),
                              modelModifiers: { number: true },
                              label: "Sequence *",
                              variant: "outlined",
                              density: "comfortable",
                              type: "number",
                              min: 0,
                              max: 99
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: $setup.menuForm.menuPgm,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.menuForm.menuPgm) = $event)),
                              items: $setup.menuTypes,
                              "item-title": "text",
                              "item-value": "value",
                              label: "Type *",
                              variant: "outlined",
                              density: "comfortable"
                            }, null, 8 /* PROPS */, ["modelValue", "items"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.menuForm.desc,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.menuForm.desc) = $event)),
                              label: "Description *",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "80"
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.menuForm.url,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.menuForm.url) = $event)),
                              label: "URL *",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "256"
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              modelValue: $setup.menuForm.helpText,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.menuForm.helpText) = $event)),
                              label: "Help Text",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "256",
                              rows: "2",
                              counter: 256
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.menuForm.pgmName,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.menuForm.pgmName) = $event)),
                              label: "Program Name",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "10"
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.menuForm.ldaSelect,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.menuForm.ldaSelect) = $event)),
                              label: "LDA Select",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "1"
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.menuForm.launch,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.menuForm.launch) = $event)),
                              label: "Launch",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "1"
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.menuForm.launchSeq,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.menuForm.launchSeq) = $event)),
                              modelModifiers: { number: true },
                              label: "Launch Seq",
                              variant: "outlined",
                              density: "comfortable",
                              type: "number",
                              min: 0,
                              max: 99
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_m_btn, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.showMenuDialog = false)),
                      text: "Cancel"
                    }),
                    _createVNode(_component_m_btn, {
                      color: "primary",
                      onClick: $setup.submitMenuItem,
                      text: $setup.editingItem ? 'Update' : 'Add',
                      disabled: !$setup.menuForm.menuId || !$setup.menuForm.desc || !$setup.menuForm.url || !$setup.menuForm.menuPgm
                    }, null, 8 /* PROPS */, ["onClick", "text", "disabled"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createCommentVNode(" Delete Confirm Dialog "),
        _createVNode(_component_v_dialog, {
          modelValue: $setup.showDeleteDialog,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.showDeleteDialog) = $event)),
          "max-width": "400"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("Confirm Delete")
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Are you sure you want to delete menu item \"" + _toDisplayString($setup.deletingItem?.menuId) + "\" (sequence " + _toDisplayString($setup.deletingItem?.sequence) + ")? ", 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_m_btn, {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.showDeleteDialog = false)),
                      text: "Cancel"
                    }),
                    _createVNode(_component_m_btn, {
                      color: "error",
                      onClick: $setup.deleteMenuItem,
                      text: "Delete"
                    }, null, 8 /* PROPS */, ["onClick"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}